<template>
  <div>
    <v-card outlined class="rounded-card">
      <v-subheader>Produtos</v-subheader>
      <v-divider/>
      <v-list>
        <template v-for="(produto, index) in produtos">
          <v-list-item :key="produto.id">
            <v-list-item-content>
              <v-list-item-title>{{ produto.produto.descricao }}</v-list-item-title>
              <v-list-item-subtitle>
                {{produto.quantidade | number('0.00')}} {{produto.unidadeMedida.descricao}}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon>
                <v-icon>
                  mdi-paperclip
                </v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-action>
              <px-detalhes-produto
                :produto="produto"
                show-obs-externa/>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="index !== (produtos.length - 1)"
                     :key="`v-div${produto.id}`"/>
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    produtos: Array,
  },
};
</script>
